import { categories } from '../../utils/variables';

export function renderbodySelectionUI(type = 'non-binary') {
    let tempUIMaleStr = `
    <div class="step__body ">
        <div class="step__image ">
            <img src="assets/images/webp/gender_male.webp" alt="Male">
            <div class="form__cols">
                <div class="form__col step__col--body">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-chest">
                                <input type="checkbox" id="maleBreast" data-category="Breasts">

                                <label for="maleBreast" data-text="Breasts">
                                    Chest
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-face">
                                <input type="checkbox" id="maleFace" data-category="Face"
                                    class="js-face-checkbox">

                                <label for="maleFace" data-text="Face" class="js-face-label">
                                    Face
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-abdomen">
                                <input type="checkbox" id="maleAbdomen" data-category="Abdomen">

                                <label for="maleAbdomen" data-text="Abdomen">
                                    Abdomen
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-back">

                                <input type="checkbox" id="maleBackButt" data-category="Back & Butt">

                                <label for="maleBackButt" data-text="Back & Butt">
                                    <span class="checkbox__element"></span>

                                    Back & Butt
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-genital">
                                <input type="checkbox" id="maleGenitals" data-category="Genital">

                                <label for="maleGenitals" data-text="Genital">
                                    Genital
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--male checkbox--male-arms">
                                <input type="checkbox" id="maleArmsLegs" data-category="Arms & Legs">

                                <label for="maleArmsLegs" data-text="Arms & Legs">
                                    <span class="checkbox__element"></span>

                                    Arms & Legs
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__col step__col--face display__none">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--hair">
                                <input type="checkbox" id="maleHair" data-category="Hair">

                                <label for="maleHair" data-text="Hair">
                                    Hair
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--eyes">
                                <input type="checkbox" id="maleEyes" data-category="Eyes">

                                <label for="maleEyes" data-text="Eyes">
                                    Eyes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--nose">
                                <input type="checkbox" id="maleNose" data-category="Nose">

                                <label for="maleNose" data-text="Nose">
                                    Nose
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--lips">
                                <input type="checkbox" id="maleLips" data-category="Lips">

                                <label for="maleLips" data-text="Lips">
                                    Lips
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--neck">
                                <input type="checkbox" id="maleNeck" data-category="Neck">

                                <label for="maleNeck" data-text="Neck">
                                    Neck
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--cheek">
                                <input type="checkbox" id="maleCheekChin"
                                    data-category="Cheek & Chin">

                                <label for="maleCheekChin" data-text="Cheek & Chin">
                                    Cheek & Chin
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--male checkbox-face--ears">
                                <input type="checkbox" id="maleEars" data-category="Ears">

                                <label for="maleEars" data-text="Ears">
                                    Ears
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;
    let tempUIFemaleStr = `
    <div class="step__body ">
        <div class="step__image ">
            <img src="assets/images/webp/gender_female.webp" alt="Female">
            <div class="form__cols">
                <div class="form__col step__col--body">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-chest">
                                <input type="checkbox" id="femaleBreast" data-category="Breasts">

                                <label for="femaleBreast" data-text="Breasts">
                                    Breasts
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-face">
                                <input type="checkbox" id="femaleFace" data-category="Face"
                                    class="js-face-checkbox">

                                <label for="femaleFace" data-text="Face" class="js-face-label">
                                    Face
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-abdomen">
                                <input type="checkbox" id="femaleAbdomen" data-category="Abdomen">

                                <label for="femaleAbdomen" data-text="Abdomen">
                                    Abdomen
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-back">

                                <input type="checkbox" id="femaleBackButt"
                                    data-category="Back & Butt">

                                <label for="femaleBackButt" data-text="Back & Butt">
                                    <span class="checkbox__element"></span>

                                    Back & Butt
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-genital">
                                <input type="checkbox" id="femaleGenitals" data-category="Genital">

                                <label for="femaleGenitals" data-text="Genital">
                                    Genital
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-arms">
                                <input type="checkbox" id="femaleArmsLegs"
                                    data-category="Arms & Legs">

                                <label for="femaleArmsLegs" data-text="Arms & Legs">
                                    <span class="checkbox__element"></span>

                                    Arms & Legs
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__col step__col--face display__none">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--hair">
                                <input type="checkbox" id="femaleHair" data-category="Hair">

                                <label for="femaleHair" data-text="Hair">
                                    Hair
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--eyes">
                                <input type="checkbox" id="femaleEyes" data-category="Eyes">

                                <label for="femaleEyes" data-text="Eyes">
                                    Eyes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--nose">
                                <input type="checkbox" id="femaleNose" data-category="Nose">

                                <label for="femaleNose" data-text="Nose">
                                    Nose
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--lips">
                                <input type="checkbox" id="femaleLips" data-category="Lips">

                                <label for="femaleLips" data-text="Lips">
                                    Lips
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--neck">
                                <input type="checkbox" id="femaleNeck" data-category="Neck">

                                <label for="femaleNeck" data-text="Neck">
                                    Neck
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--cheek">
                                <input type="checkbox" id="femaleCheekChin"
                                    data-category="Cheek & Chin">

                                <label for="femaleCheekChin" data-text="Cheek & Chin">
                                    Cheek & Chin
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox-face checkbox-face--female checkbox-face--ears">
                                <input type="checkbox" id="femaleEars" data-category="Ears">

                                <label for="femaleEars" data-text="Ears">
                                    Ears
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;

    let tempUINonBinaryStr = `
    <div class="step__body">
        <div class="step__image">
            <img class="js-non-binary-figure" src="assets/images/webp/gender_female.webp"
                alt="Female">

            <div class="form__cols">
                <div class="form__col step__col--body">
                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-chest">
                                <input type="checkbox" id="nonBinaryBreast"
                                    data-category="Breasts">

                                <label for="nonBinaryBreast" data-text="Breasts">
                                    Breasts
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-face">
                                <input type="checkbox" id="nonBinaryFace"
                                    data-category="Face" class="js-face-checkbox">

                                <label for="nonBinaryFace" data-text="Face"
                                    class="js-face-label">
                                    Face
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-abdomen">
                                <input type="checkbox" id="nonBinaryAbdomen"
                                    data-category="Abdomen">

                                <label for="nonBinaryAbdomen" data-text="Abdomen">
                                    Abdomen
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-back">

                                <input type="checkbox" id="nonBinaryBackButt"
                                    data-category="Back & Butt">

                                <label for="nonBinaryBackButt" data-text="Back & Butt">
                                    <span class="checkbox__element"></span>

                                    Back & Butt
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-genital">
                                <input type="checkbox" id="nonBinaryGenitals"
                                    data-category="Genital">

                                <label for="nonBinaryGenitals" data-text="Genital">
                                    Genital
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div class="checkbox checkbox--female checkbox--female-arms">
                                <input type="checkbox" id="nonBinaryArmsLegs"
                                    data-category="Arms & Legs">

                                <label for="nonBinaryArmsLegs" data-text="Arms & Legs">
                                    <span class="checkbox__element"></span>

                                    Arms & Legs
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__col step__col--face display__none">
                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--hair">
                                <input type="checkbox" id="nonBinaryHair"
                                    data-category="Hair">

                                <label for="nonBinaryHair" data-text="Hair">
                                    Hair
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--eyes">
                                <input type="checkbox" id="nonBinaryEyes"
                                    data-category="Eyes">

                                <label for="nonBinaryEyes" data-text="Eyes">
                                    Eyes
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--nose">
                                <input type="checkbox" id="nonBinaryNose"
                                    data-category="Nose">

                                <label for="nonBinaryNose" data-text="Nose">
                                    Nose
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--lips">
                                <input type="checkbox" id="nonBinaryLips"
                                    data-category="Lips">

                                <label for="nonBinaryLips" data-text="Lips">
                                    Lips
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--neck">
                                <input type="checkbox" id="nonBinaryNeck"
                                    data-category="Neck">

                                <label for="nonBinaryNeck" data-text="Neck">
                                    Neck
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--cheek">
                                <input type="checkbox" id="nonBinaryCheekChin"
                                    data-category="Cheek & Chin">

                                <label for="nonBinaryCheekChin" data-text="Cheek & Chin">
                                    Cheek & Chin
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__controls">
                            <div
                                class="checkbox-face checkbox-face--female checkbox-face--ears">
                                <input type="checkbox" id="nonBinaryEars"
                                    data-category="Ears">

                                <label for="nonBinaryEars" data-text="Ears">
                                    Ears
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div
        </div>
    </div>
    `;
    let tempDom = document.querySelector(
        '.bodyAreaSelection__container .content__wrapper'
    );
    if (tempDom) {
        if (type === 'male') tempDom.innerHTML = tempUIMaleStr;

        if (type === 'female') tempDom.innerHTML = tempUIFemaleStr;

        if (type === 'non-binary') tempDom.innerHTML = tempUINonBinaryStr;
    }
    activeForCategories();
}

function activeForCategories() {
    const nameOfCategories = categories.map((item) => item.name);
    const inputs = document.querySelectorAll(
        '.bodyAreaSelection__container .form__row input[type=checkbox]'
    );

    inputs.forEach((input) => {
        const categoryOfInput = input.dataset.category;
        if (nameOfCategories.includes(categoryOfInput)) {
            input.parentElement
                .querySelector('label')
                ?.classList.add('isActive');
        }
    });
}
